import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { AlertService } from 'src/app/services/alert.service';
import { ProductService } from 'src/app/services/product.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-updatepricepopup',
  templateUrl: './updatepricepopup.component.html',
  styleUrls: ['./updatepricepopup.component.scss']
})
export class UpdatepricepopupComponent implements OnInit {

  
  form1:FormGroup
  financeyear: string;
  dateDisabled: boolean;
  newunitPrice: number;
  gst:any;
  unitprice: any;
  gstList: any;
  gstListCopy: any;
  invoice_filename: any;
  fileType: number;
  leafletfiles: any;
  filesResult: any;
  attachmentData: any;
  isSubmit: boolean = false;
  salesInvoiceImagePath: any;
  dateDetails: any;
  changevalue: boolean=true;

  
  constructor(
    private formBuilder:FormBuilder,
    private productService:ProductService,
    private alertService:AlertService,
    public dialogRef: MatDialogRef<UpdatepricepopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToEdit: any,
  ) { }

  ngOnInit(): void {
    this.initialValidators()

    this.getDate();
    this.salesInvoiceImagePath=this.dataRecievedToEdit.salseInvoiceImagePath;
    this.invoice_filename=this.salesInvoiceImagePath;
    this.dateDetails=JSON.parse(localStorage.getItem('dateDetails'))
    this.newunitPrice=this.dataRecievedToEdit.unitPrice;
    
    
  }

  initialValidators()
  {
    this.form1 = this.formBuilder.group({
      financialYear: [""],
      stateEffectiveDate: ["", Validators.required],
      effectiveEndDate: ["", Validators.required],
      unitPrice: ["", Validators.required],
      price: ["", Validators.required],
      dbtgstId: ["", Validators.required],
      invoice_file: ["", Validators.required],
      invoice_filename: ["", ""]
    });
  }

  getDate()
  {
    var year = "";
    var curyear = 0;
    var currentYear = new Date().getFullYear();
    var currentMonth = new Date().getMonth();
    if (currentMonth == 1 || currentMonth == 2 || currentMonth == 3) {
      var year = currentYear - 1 + "-" + currentYear;
      curyear = currentYear - 1;
    } else {
      var year = currentYear + "-" + (currentYear + 1);
      curyear = currentYear;
    }
    this.financeyear = year;
    this.form1.controls["financialYear"].setValue(
      currentYear + "-" + (currentYear + 1)
    );

    var stdate = curyear + "/" + "04" + "/" + "01";
    var eddate = curyear + 1 + "/" + "03" + "/" + "31";

    var startdate = moment(new Date(stdate));
    var enddate = moment(new Date(eddate));
    this.form1.controls["stateEffectiveDate"].setValue(startdate);
    this.form1.controls["effectiveEndDate"].setValue(enddate);
    this.dateDisabled = true;
    this.getgstList(true);

  }

  getgstList(refresh: boolean) {
    this.productService.getgstList(refresh).subscribe(result => {
      if (result) {
        this.gstList = result;
        this.gstListCopy = this.gstList;
        this.gstListCopy = this.gstListCopy.slice();
        this.form1.controls["dbtgstId"].setValue(1);

        this.form1.patchValue(this.dataRecievedToEdit)

        this.gst = this.gstListCopy.filter(i => i.key == this.form1.value.dbtgstId);

      }
    });
  }

  unitPriceevent(event) {
    this.changevalue=false
    event.target.value;
    if (event.target.value != "") {
      this.newunitPrice = parseInt(event.target.value);
      if (this.gst == null || this.gst == undefined || this.gst == "") {
        this.gst = 0;
        this.unitprice =
          this.newunitPrice * (this.gst / 100) + this.newunitPrice;
        this.form1.controls["price"].setValue(this.unitprice);
      } else {
        this.unitprice =
          this.newunitPrice * (this.gst[0].price / 100) + this.newunitPrice;
        this.form1.controls["price"].setValue(this.unitprice);
      }
    } else {
      this.form1.controls["price"].setValue(" ");
    }
  }

  onChange() {
    this.changevalue=false
    this.gst = this.gstListCopy.filter(i => i.key == this.form1.value.dbtgstId);
    this.unitprice =
      this.newunitPrice * (this.gst[0].price / 100) + this.newunitPrice;
    this.form1.controls["price"].setValue(this.unitprice);
  }


  downloadsalse() {
    let src =
      environment.imageBaseUrl +
      "DBT/SalesInvoice/" +
      this.salesInvoiceImagePath;
    window.open(encodeURI(src), "_blank");
  }

  onInvoiceFileSelected(event1: any) {
    const file = event1.target.files[0];
    if (file.type === "application/pdf") {
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize <= 2048) {
        this.invoice_filename = file.name;
        let checkType = file.type;
        let getFileType = checkType.split("/");
        // this.fileType = getFileType[1]
        if (getFileType[1] == "pdf") {
          this.fileType = 2;
        } else {
          this.fileType = 1;
        }
        if (file) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.changevalue=true
            this.leafletfiles = event.target.result;
            this.filesResult = event.target.result.split(",")[1];
            this.form1.controls["invoice_file"].setValue(this.filesResult);
            this.form1.controls["invoice_filename"].setValue(file.name);
            this.attachmentData={
              id: 0,
              base64String: this.filesResult,
              attachmentFilename: file.name,
              fileType: this.fileType,
              attachmentType: 25
            };
          };
        }
      } else {
        this.alertService.warning(
          "File size is large, Please upload less than 2 MB"
        );
      }
    } else {
      this.alertService.warning("Please upload PDF only");
    }
  }

  back()
  {
    this.dialogRef.close(false);
  }

  submit()
  {
    this.isSubmit = true;
  if(this.changevalue)
  {
    var data={
      id:0,
      dbtProductInfoId:this.dataRecievedToEdit.id,
      financialYearId:this.dateDetails[0].key,
      price:this.form1.value.price,
      unitPrice:this.form1.value.unitPrice,
      dbtgstId:this.form1.value.dbtgstId,
      effectiveFromTs: moment(this.form1.value.stateEffectiveDate).format('YYYY-MM-DD'),
      effectiveToTs: moment(this.form1.value.effectiveEndDate).format('YYYY-MM-DD'),
      attachment: this.attachmentData
    }

    this.productService.updatePriceSave(data).subscribe(res=>{
      if(res.isSuccess)
      {
        this.dialogRef.close(true);
        this.alertService.success("Price Updated Successfully")
      }
      else{
        this.alertService.error(res.htmlFormattedFailures)
      }
    })
  }
  else{
    this.alertService.error("Due to change in Price, Please Re-upload the Copy of latest Sales Invoice")
  }
  }

}
